export const NAV_LIST = ['Home', 'Phones', 'Tablets', 'Accessories'];
